'use es6';

import * as params from '../helpers/params';
import { buildUrl, parseUrl } from '../helpers/url';
import { environmentUrl, hubletApi, hubletSubdomainPostfix, onResponse, onResponseError, resolveApi, retry, query } from './core';
import { maybeGetParentIframe, UNAUTHORIZED_MESSAGE } from '../helpers/iframe';
import { responseError } from '../helpers/response';
import { redirectTo } from '../helpers/location';
import authCache from '../helpers/authCache';
import { Promise } from '../helpers/promise';
import { set } from '../helpers/update';
export var defaults = function defaults(options) {
  return Object.assign({}, {
    timeout: 14000,
    withCredentials: true,
    portalId: window.hubspot && window.hubspot.portal && window.hubspot.portal.id,
    labs: window.hubspot && window.hubspot['__hub-http-labs']
  }, options);
};

var labEnabled = function labEnabled(labKey, options) {
  var localStorageKey = "HUB-HTTP-LABS:" + labKey;
  var labOverride = options.localStorage && options.localStorage.getItem(localStorageKey);

  if (labOverride && labOverride.toLowerCase() === 'true') {
    // eslint-disable-next-line no-console
    console.log("Using localStorage override for " + localStorageKey + ": " + labOverride);
    return labOverride.toLowerCase() === 'true';
  }

  return typeof options.labs === 'object' && options.labs[labKey];
};

export var lab = function lab(labKey, middleware) {
  var fallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (o) {
    return o;
  };
  return function (options) {
    return labEnabled(labKey, options) ? middleware(options) : fallback(options);
  };
};
export var hubapi = environmentUrl(hubletApi('api', 'hubspot'));
export var maybeUseIframeRequest = function maybeUseIframeRequest(options) {
  var _parseUrl = parseUrl(options.url),
      hostname = _parseUrl.hostname;

  var useIframeRequest = hostname.indexOf("api" + hubletSubdomainPostfix() + ".hubspot") === 0;
  return set('useIframeRequest', useIframeRequest)(options);
};
export var setRequest = maybeUseIframeRequest;
export var timeoutInQuery = function timeoutInQuery(options) {
  return typeof options.timeout === 'number' ? query({
    clienttimeout: options.timeout
  })(options) : options;
};

var buildLogoutUrl = function buildLogoutUrl(options) {
  var hostname = resolveApi(hubletApi('app', 'hubspot'));
  var loginDescriptor = {
    hostname: hostname,
    path: '/login/'
  };
  var loginQuery = {
    loginRedirectUrl: options.location.href
  };

  if (options.portalId) {
    loginQuery.loginPortalId = options.portalId;
  }

  loginDescriptor.query = params.stringify(loginQuery);
  return buildUrl(loginDescriptor);
};

var onRedirectToLogin = function onRedirectToLogin(options) {
  return authCache.clear(options);
};

var handleLogoutFromRequest = function handleLogoutFromRequest(options) {
  var redirectUrl = buildLogoutUrl(options);

  if (redirectTo(redirectUrl, options, onRedirectToLogin)) {
    throw new Error('Aborting: redirection in progress');
  }

  return options;
};

var handleLogoutFromResponse = function handleLogoutFromResponse(response) {
  var options = response.options;
  var redirectUrl = buildLogoutUrl(options);
  redirectTo(redirectUrl, options, onRedirectToLogin);
  return Promise.reject(responseError(response, 'Aborting: redirection in progress'));
};

export var logoutOnError = onResponseError(handleLogoutFromResponse);
export var logoutOn = function logoutOn(predicate) {
  return function (options) {
    return onResponse(function (response) {
      if (predicate(response)) {
        return handleLogoutFromResponse(response);
      }

      return response;
    })(options);
  };
};
export var logoutOnUnauthorized = function logoutOnUnauthorized(options) {
  var parentWindow = maybeGetParentIframe();

  if (parentWindow) {
    return onResponse(function (response) {
      if (response.status === 401) {
        parentWindow.postMessage(UNAUTHORIZED_MESSAGE, '*');
        return Promise.reject(responseError(response, 'Aborting: notifying parents of unauthorized response'));
      }

      return response;
    })(options);
  }

  return logoutOn(function (response) {
    return response.status === 401;
  })(options);
};
export var logoutOnMissingPortalId = function logoutOnMissingPortalId(options) {
  if (!options.portalId) {
    // eslint-disable-next-line no-console
    console.log('[hub-http] Could not find portal id. Redirecting');
    return handleLogoutFromRequest(options);
  }

  return options;
};
export var retryOnError = retry(function (response) {
  return response.options.method === 'GET' && (response.status >= 500 || response.status === 0 && response.errorCode === 'NETWORKERROR');
}, {
  reason: 'Server error'
});